import { Entry } from '../Entry'

export function Entry20251217() {
  return (
    <Entry title="2025 Dec 17 - v3.11.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/20843/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
